
/*
 * ! @chakra-ui/vue v0.11.0 by Jonathan Bakebwa @codebender828
 * MIT License
 * https://github.com/chakra-ui/chakra-ui-vue
 */

/**
 * Returns truncation style props for text elements.
 * @todo Add line-clamp features for text.
 */
var useTruncated = function useTruncated() {
  return {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
  };
};

export { useTruncated as u };
